// "I speak" (UI-C2, D-21): the 30 languages the engine recognises. One row per language:
// BCP 47 tag | English name | Arabic name | native name. Speaking `zh` covers Mandarin and the model's
// regional dialects by auto-detection; the speaker never picks a dialect or a script (script is a reading
// choice). No quality claim about any language belongs in the UI.
export interface Language {
  tag: string;
  en: string;
  ar: string;
  native: string;
}

export const SPEAK_LANGUAGES: readonly Language[] = [
  { tag: "ar", en: "Arabic", ar: "العربية", native: "العربية" },
  { tag: "en", en: "English", ar: "الإنجليزية", native: "English" },
  { tag: "zh", en: "Chinese (Mandarin)", ar: "الصينية", native: "中文" },
  { tag: "yue", en: "Cantonese", ar: "الكانتونية", native: "粵語" },
  { tag: "de", en: "German", ar: "الألمانية", native: "Deutsch" },
  { tag: "fr", en: "French", ar: "الفرنسية", native: "Français" },
  { tag: "es", en: "Spanish", ar: "الإسبانية", native: "Español" },
  { tag: "pt", en: "Portuguese", ar: "البرتغالية", native: "Português" },
  { tag: "id", en: "Indonesian", ar: "الإندونيسية", native: "Bahasa Indonesia" },
  { tag: "it", en: "Italian", ar: "الإيطالية", native: "Italiano" },
  { tag: "ko", en: "Korean", ar: "الكورية", native: "한국어" },
  { tag: "ru", en: "Russian", ar: "الروسية", native: "Русский" },
  { tag: "th", en: "Thai", ar: "التايلاندية", native: "ไทย" },
  { tag: "vi", en: "Vietnamese", ar: "الفيتنامية", native: "Tiếng Việt" },
  { tag: "ja", en: "Japanese", ar: "اليابانية", native: "日本語" },
  { tag: "tr", en: "Turkish", ar: "التركية", native: "Türkçe" },
  { tag: "hi", en: "Hindi", ar: "الهندية", native: "हिन्दी" },
  { tag: "ms", en: "Malay", ar: "الملايوية", native: "Bahasa Melayu" },
  { tag: "nl", en: "Dutch", ar: "الهولندية", native: "Nederlands" },
  { tag: "sv", en: "Swedish", ar: "السويدية", native: "Svenska" },
  { tag: "da", en: "Danish", ar: "الدنماركية", native: "Dansk" },
  { tag: "fi", en: "Finnish", ar: "الفنلندية", native: "Suomi" },
  { tag: "pl", en: "Polish", ar: "البولندية", native: "Polski" },
  { tag: "cs", en: "Czech", ar: "التشيكية", native: "Čeština" },
  { tag: "fil", en: "Filipino", ar: "الفلبينية", native: "Filipino" },
  { tag: "fa", en: "Persian", ar: "الفارسية", native: "فارسی" },
  { tag: "el", en: "Greek", ar: "اليونانية", native: "Ελληνικά" },
  { tag: "hu", en: "Hungarian", ar: "المجرية", native: "Magyar" },
  { tag: "mk", en: "Macedonian", ar: "المقدونية", native: "Македонски" },
  { tag: "ro", en: "Romanian", ar: "الرومانية", native: "Română" },
];
